"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextVariantColorEnum = void 0;
var TextVariantColorEnum;
(function (TextVariantColorEnum) {
    TextVariantColorEnum["Default"] = "default";
    TextVariantColorEnum["Inverse"] = "inverse";
    TextVariantColorEnum["Primary"] = "primary";
    TextVariantColorEnum["Secondary"] = "secondary";
    TextVariantColorEnum["Positive"] = "positive";
    TextVariantColorEnum["Negative"] = "negative";
    TextVariantColorEnum["Warning"] = "warning";
    TextVariantColorEnum["Gray"] = "gray";
    TextVariantColorEnum["White"] = "white";
    TextVariantColorEnum["Black"] = "black";
})(TextVariantColorEnum = exports.TextVariantColorEnum || (exports.TextVariantColorEnum = {}));
//# sourceMappingURL=text-variant-color-enum.js.map